import { getAuthenticatedHttpClient } from "@edx/frontend-platform/auth";

var API_URL;
var API_URL_LOGIN;

var env = "production";

const environment = {
  DEVELOPMENT: "development",
  PRODUCTION: "production",
};
var authorizationHeader = { headers: { 'Authorization': `Bearer` }};

const authToken = JSON.parse(window.localStorage.getItem('fetpAT') || '{}');

if (authToken && authToken.access_token) {
  authorizationHeader = {
    headers: { 'Authorization': `Bearer ${authToken.access_token}` }
  };
}


if (env === environment.PRODUCTION) {
  API_URL = `http://local.edly.io:8000/`;
  API_URL_LOGIN = "http://local.edly.io:8000/api/";
}

if (env === environment.DEVELOPMENT) {
  API_URL = `http://local.edly.io:8000/`;
  API_URL_LOGIN = "http://local.edly.io:8000/api/";
}

function clearAllPaths(window, cookieBase) {
  var p = window.location.pathname.split("/");
  window.document.cookie = cookieBase + "; path=/";
  while (p.length > 0) {
    window.document.cookie = cookieBase + "; path=" + p.join("/");
    p.pop();
  }
}

function deleteAllCookies() {
  var cookies = window.document.cookie.split("; ");
  for (var c = 0; c < cookies.length; c++) {
    var encodedCookieName = encodeURIComponent(
      cookies[c].split("=")[0]
    );
    var cookieBase =
      encodedCookieName + "=; expires=Thu, 01-Jan-1970 00:00:01 GMT";
    clearAllPaths(window, cookieBase);

    var d = window.location.hostname.split(".");
    while (d.length > 0) {
      clearAllPaths(window, cookieBase + "; domain=" + d.join("."));
      d.shift();
    }
  }
}

async function getWithAuth(url, config) {
  try {
    showLoader();
    const response = await getAuthenticatedHttpClient().get(url,authorizationHeader, config);
    hideLoader();
    return response;
  } catch (error) {
    hideLoader();
    return handleApiError(error);
  }
}

async function postWithAuth(url, data) {
  try {
    showLoader();
    const response = await getAuthenticatedHttpClient().post(url, data ,authorizationHeader);
    hideLoader();
    return response;
  } catch (error) {
    hideLoader();
    return handleApiError(error);
  }
}

async function patchWithAuth(url, payload) {
  try {
    showLoader();
    const response = await getAuthenticatedHttpClient().patch(url, payload,authorizationHeader);
    hideLoader();
    return response;
  } catch (error) {
    hideLoader();
    return handleApiError(error);
  }
}

async function deleteWithAuth(url) {
  try {
    showLoader();
    const response = await getAuthenticatedHttpClient().delete(url,authorizationHeader);
    hideLoader();
    return response;
  } catch (error) {
    hideLoader();
    return handleApiError(error);
  }
}

function handleApiError(error) {
  const {
    customAttributes: { httpErrorStatus },
  } = error;
  if (httpErrorStatus === 401) {
    window.localStorage.clear();
    deleteAllCookies();
    window.location.href = "/login";
  }
}

const showLoader = () => {
  document.body.classList.add("loading-indicator");
};

const hideLoader = () => {
  setTimeout(() => {
    document.body.classList.remove("loading-indicator");
  }, 1000);
};

export {
  API_URL,
  API_URL_LOGIN,
  handleApiError,
  getWithAuth,
  postWithAuth,
  patchWithAuth,
  deleteWithAuth,
  deleteAllCookies
};
